import React from 'react';
import PropTypes from 'prop-types';
import { Col, Modal, Row } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faPlus, faUpload } from '@fortawesome/pro-solid-svg-icons';

import 'animate.css';

export default function IntroStep({ onFromExistingSelected, onFromScratchSelected, onUploadDocSelected }) {
  return (
    <Modal.Body className="py-5" >
      <h2 className="text-center mb-5">
        <strong>Create a new listing</strong>
      </h2>
      <Row>
        <Col md={8} mdOffset={2}>
          {onFromExistingSelected && (
            <div
              className="btn btn-light d-block py-4 my-4"
              name="from-existing"
              onClick={onFromExistingSelected}
            >
              <div className="text-center text-primary">
                <FontAwesomeIcon icon={faBuilding} size="3x" />
              </div>
              <h5 className="text-center" style={{ fontSize: '15px' }}>Start from an existing property</h5>
            </div>
          )}
          <div
            className="btn btn-light d-block py-4 my-4"
            name="from-scratch"
            onClick={onFromScratchSelected}
          >
            <div className="text-center text-primary">
              <span
                className="position-relative d-inline-block from-scratch-icon-wrapper"
              >
                <FontAwesomeIcon
                  className="position-absolute top-50 start-50 translate-middle"
                  icon={faPlus}
                  size="2x"
                />
              </span>

            </div>
            <h5 className="text-center" style={{ fontSize: '15px' }}>Start a new listing from scratch</h5>
          </div>
          {onUploadDocSelected && (
            <div
              className="btn btn-light d-block py-4 my-4"
              name="upload-doc"
              onClick={onUploadDocSelected}
            >
              <div className="text-center text-primary">
                <FontAwesomeIcon icon={faUpload} size="3x" />
              </div>
              <h5 className="text-center" style={{ fontSize: '15px' }}>
                Upload a listing document
              </h5>
            </div>
          )}
        </Col>
      </Row>
    </Modal.Body>
  );
}

IntroStep.propTypes = {
  onFromExistingSelected: PropTypes.func,
  onFromScratchSelected: PropTypes.func.isRequired,
  onUploadDocSelected: PropTypes.func
};
